import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import CommonDatasetsSchemaExplorerComponent from 'webapp/components/common/datasets/schema-explorer';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';

import type Source from 'webapp/models-custom/source';
import type SourceType from 'webapp/models-custom/source-type';

interface Args {
	sourceType: SourceType;
	source?: Source | null;
}

export default class MetricLibraryGridBlockDatasetComponent extends Component<Args> {
	@service('account') declare accountService: Service.Account;
	@service('connect') declare connectService: Service.Connect;

	get sourceName() {
		return this.args.sourceType.name;
	}

	get integrationKey() {
		return this.args.sourceType.key;
	}

	get source() {
		return this.args.source;
	}

	@action
	createNewDataset() {
		if (this.source) {
			this.connectService.addNewDataset(this.integrationKey, {
				sourceId: this.source.numericId!,
				dataSourceName: this.source.title,
			});
		} else {
			this.connectService.addNewDataset();
		}
	}
	<template>
		<div class="ml-section ml-section--datasets">
			<div class="card">
				<div class="left">
					<img src="/images/datasets/explore_datasets.svg" alt="Explore datasets" />
				</div>
				<div class="center">
					<h3>
						Create a dataset with
						{{this.sourceName}}
						data
					</h3>
					<p>
						Prepare a custom table of raw data to use as the source of your metrics.
						Empowers you to do drill-down to row-level data, breakdown & filter
						dashboards by one or more dimensions, and perform advanced filtering &
						calculations.
						{{#unless
							this.accountService.hideDataboxNotWhiteLabeledContentForNonAdmins
						}}
							<a
								href="https://help.databox.com/understanding-datasets"
								target="_blank"
							>
								Learn more
							</a>
						{{/unless}}
					</p>
					<div class="option-items">
						<div class="option-item">
							<CommonUiIconComponent @name="Check" @size="xs" />
							<strong>View, filter, export</strong>&nbsp;raw data
						</div>
						<div class="option-item">
							<CommonUiIconComponent @name="Check" @size="xs" />
							<strong>Calculate columns</strong>&nbsp;with formulas
						</div>
						<div class="option-item">
							<CommonUiIconComponent @name="Check" @size="xs" />
							<strong>Merge data</strong>
						</div>
					</div>
				</div>
				<div class="right">
					{{! TODO: Datasets - Add info about supported entities for replicator integraions }}
					<CommonDatasetsSchemaExplorerComponent
						@dataSourceTypeName={{this.integrationKey}}
						@origin="metric-library"
					/>
					<a role="button" class="button icon" {{on "click" this.createNewDataset}}>
						<CommonUiIconComponent @name="Plus" @size="sm" />
						New dataset
					</a>
				</div>
			</div>
		</div>
	</template>
}
